module.exports = __webpack_public_path__ + "static/imagem-sobre-01-d36d8a78f4e010e639907034947bdf5e.jpg";